import React from 'react';
import { GraduationCap, Users, Trophy, Star, ArrowRight, Youtube } from 'lucide-react';
import Button from '../components/common/Button';
import Footer from '../components/Footer';
import { PLATFORM_LINKS, SOCIAL_LINKS, IMAGES } from '../config/constants';

const BioPage = () => {
  const handleCourseClick = () => {
    window.open(PLATFORM_LINKS.COURSES, '_blank');
  };

  const handleYoutubeClick = () => {
    window.open(SOCIAL_LINKS.YOUTUBE_CHANNEL, '_blank');
  };

  const courses = [
    {
      title: "Java Expert",
      description: "Do básico ao avançado com projetos reais",
      students: "2.5k+",
      rating: 4.9,
      icon: <GraduationCap className="w-6 h-6" />
    },
    {
      title: "Spring Boot Pro",
      description: "Domine o framework mais usado do mercado",
      students: "1.8k+",
      rating: 4.8,
      icon: <GraduationCap className="w-6 h-6" />
    }
  ];

  return (
    <div className="min-h-screen bg-[#0b0c0d]">
      <main className="container mx-auto px-4">
        {/* YouTube Section */}
        <section className="min-h-[60vh] flex flex-col md:flex-row items-center justify-center gap-12 py-12 border-b border-white/10">
          <div className="w-full md:w-1/2 flex justify-center">
            <div className="relative">
              <div className="w-64 h-64 md:w-96 md:h-96 rounded-2xl overflow-hidden border-2 border-red-500/30 shadow-[0_0_30px_rgba(255,0,0,0.2)]">
                <img 
                  src={IMAGES.INSTRUCTOR}
                  alt="Daniele Leão" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-6 right-0 bg-red-600 text-white px-6 py-3 rounded-full shadow-lg flex items-center gap-2">
                <Youtube className="w-5 h-5" />
                <span className="font-bold">+100k inscritos</span>
              </div>
            </div>
          </div>

          <div className="w-full md:w-1/2 text-white space-y-6">
            <h1 className="text-4xl md:text-5xl font-bold">
              Daniele Leão
            </h1>
            
            <p className="text-xl text-gray-300">
              Conteúdo gratuito sobre Java, Spring Boot e carreira dev.
              Acompanhe dicas práticas e tutoriais toda semana!
            </p>

            <div className="flex gap-4 items-center">
              <div className="flex items-center gap-2">
                <Users className="w-5 h-5 text-red-500" />
                <span className="text-lg">100k+ inscritos</span>
              </div>
              <div className="w-1 h-1 bg-white/30 rounded-full"></div>
              <div className="flex items-center gap-2">
                <Star className="w-5 h-5 text-yellow-500" />
                <span className="text-lg">500+ vídeos</span>
              </div>
            </div>

            <Button 
              onClick={handleYoutubeClick}
              size="large"
              className="!bg-red-600 hover:!bg-red-700 transition-colors duration-300 group"
            >
              <span className="flex items-center justify-center gap-2">
                <Youtube className="w-5 h-5" />
                Inscreva-se no Canal
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
              </span>
            </Button>
          </div>
        </section>

        {/* Courses Section */}
        <section className="min-h-[60vh] flex flex-col md:flex-row items-center justify-center gap-12 py-12">
          <div className="w-full md:w-1/2 flex justify-center">
            <div className="relative">
              <div className="w-64 h-64 md:w-96 md:h-96 rounded-2xl overflow-hidden border-2 border-[#05f217]/30 shadow-[0_0_30px_rgba(5,242,23,0.2)]">
                <img 
                  src="https://images.pexels.com/photos/4709285/pexels-photo-4709285.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" 
                  alt="Daniele Leão" 
                  className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500"
                />
              </div>
              <div className="absolute -bottom-6 right-0 bg-[#f2055c] text-white px-6 py-3 rounded-full shadow-lg flex items-center gap-2">
                <GraduationCap className="w-5 h-5" />
                <span className="font-bold">Java Expert</span>
              </div>
              <div className="absolute -top-4 -right-4 bg-[#05f217] text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-2">
                <Trophy className="w-5 h-5" />
                <span className="font-bold">Cursos</span>
              </div>
            </div>
          </div>

          <div className="w-full md:w-1/2 text-white space-y-6">
            <div className="flex items-center gap-3 mb-2">
              <GraduationCap className="w-8 h-8 text-[#05f217]" />
              <h2 className="text-4xl md:text-5xl font-bold">
                Cursos
              </h2>
            </div>
            
            <p className="text-xl text-gray-300">
              Transforme sua carreira com cursos práticos e direto ao ponto.
              Aprenda Java com quem tem mais de 20 anos de experiência no mercado.
            </p>

            <div className="space-y-4">
              {courses.map((course, index) => (
                <div 
                  key={index}
                  className="bg-white/5 rounded-xl p-6 backdrop-blur-sm border border-white/10 hover:border-[#05f217]/50 transition-colors duration-300"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <span className="w-10 h-10 rounded-full bg-[#05f217]/10 flex items-center justify-center">
                      {course.icon}
                    </span>
                    <h3 className="text-xl font-bold">{course.title}</h3>
                  </div>
                  <p className="text-gray-400 mb-4">{course.description}</p>
                  <div className="flex items-center justify-between text-sm">
                    <div className="flex items-center gap-2">
                      <Users className="w-4 h-4 text-[#05f217]" />
                      <span>{course.students} alunos</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Star className="w-4 h-4 text-yellow-500" />
                      <span>{course.rating}/5.0</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <Button 
              onClick={handleCourseClick}
              size="large"
              className="mt-8 !bg-[#05f217] hover:!bg-[#f2055c] transition-colors duration-300 group w-full"
            >
              <span className="flex items-center justify-center gap-2">
                Acessar Cursos
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
              </span>
            </Button>

            <p className="text-sm text-gray-400 text-center">
              Junte-se a mais de 5.000 alunos que já transformaram suas carreiras
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default BioPage;